import { memo, PropsWithChildren } from 'react';
import cls from 'classnames';

import styles from './MenuItemSeparator.module.css';

interface MenuItemSeparatorProps {
  borderless?: boolean;
  light?: boolean;
  className?: string;
}

function MenuItemSeparator(props: PropsWithChildren<MenuItemSeparatorProps>) {
  const { children, borderless = false, light = false, className } = props;

  const separatorClassName = cls(
    {
      [styles.menuItemSeparator]: Boolean(children),
      [styles.menuItemSeparatorLine]: !children,
      [styles.menuItemSeparatorBordered]: !borderless,
      [styles.menuItemSeparatorLight]: light,
    },
    className,
  );

  return <div className={separatorClassName}>{children}</div>;
}

export default memo(MenuItemSeparator);
